import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import MenuList from './MenuList';
import {
  getNewBrandDirectoryDesktopFlag,
  getSearchFlags,
  getStreetFlags
} from '../../../../refresh/selectors/featureFlagsSelector';
import { STREET_STORE } from '../../../../constants/constant';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';
import { getSearchExpFlags } from '../../../../utils/products';
import { getAmplitudeVariantPayload, getAmplitudeVariantPayloadMap } from '../../../../utils/amplitudeCommon';

const { useState } = React;

const Navigation = props => {
  const {
    category = true,
    metaData,
    newDesignLuxe = false,
    isNewBrandDirectoryDesktop,
    isStreet
  } = props;
  const [mouseInSideDiv, setMouseInSideDiv] = useState('No');
  const [activeDropdown,setActiveDropdown] = useState(0)
  let {
    metaData: {
      sis = false,
      subHeaderHeight = 0,
      current: { navigation: subStoreNavigation } = {}
    } = {},
    navigation: navdata = {},
    ABFlagObj
  } = props;
  /* if (sis) {
    navdata = subStoreNavigation;
  } */

  if (_isEmpty(navdata)) {
    return null;
  }
  const ulStyle =
    sis && !isStreet && !newDesignLuxe ? { paddingTop: subHeaderHeight === 100 ? 10 : 0 } : null;
  const ulClass = `level-first ${sis && !isStreet && 'transition-element'}`;
  return (
    <div className="menu-newlist" role="navigation">
      <ul
        className={ulClass}
        style={ulStyle}
        onMouseEnter={() => setMouseInSideDiv('Yes')}
        onMouseLeave={() => setMouseInSideDiv('No')}
      >
        {navdata.map((data, i) => {
          let { name } = data;
          if (name) {
            return (
              <MenuList
                data={data}
                key={i}
                category={category}
                metaData={metaData}
                newDesignLuxe={newDesignLuxe}
                isStreet={isStreet}
                isBrands={name.toUpperCase() === 'BRANDS'}
                isNewBrandDirectoryDesktop={isNewBrandDirectoryDesktop}
                isMouseInSideDiv={mouseInSideDiv}
                ABFlagObj={ABFlagObj}                
                setActiveDropdown={setActiveDropdown}
                activeDropdown={activeDropdown}
                menuIndex={i}
                />
            );
          }
        })}
      </ul>
    </div>
  );
};

function mapStateToProps(state) {
  const navigation = state.navigation;
  const storeName = getCurrentStore(state);
  const { isThemeEnableWeb } = getStreetFlags(state);

  const searchFlags = getAmplitudeVariantPayload('searchExpFlags',state, getSearchFlags(state));
  

  let ABFlagObj = (state?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(searchFlags, state) : getSearchExpFlags(searchFlags);
  

  return {
    navigation: navigation.data ? navigation.data.childDetails : {},
    metaData: state.metaData,
    isNewBrandDirectoryDesktop: getNewBrandDirectoryDesktopFlag(state),
    isStreet: isThemeEnableWeb === 'ON' && storeName === STREET_STORE,
    ABFlagObj: ABFlagObj || {}
  };
}

export default connect(mapStateToProps)(Navigation);
